export default {
    path: '/operationLog',
    name: 'OperationLog',
    component: () => import(/* webpackChunkName: "operationLog" */ '../../views/operationLog/operationLog.vue')
}